import { PropType } from 'vue';
import { Options } from 'vue-class-component';
import {
  ConditionDTO,
  PlantDetailDTO,
  TriggerDTO,
} from '@/../client-generator/generated-clients/plants';
import SceneTimeObject from '../../SceneTimeObject/SceneTimeObject.vue';
import { BaseSceneSlide, SceneSlideType } from '../SceneSlide.base';

@Options({
  name: 'ConditionSceneSlide',
  props: {
    sceneId: {
      type: String,
      required: true,
    },
    conditions: {
      type: Array.of(Object as PropType<ConditionDTO>),
      required: true,
    },
    plant: {
      type: Object as PropType<PlantDetailDTO>,
    },
  },
  components: {
    SceneTimeObject,
  },
})
export default class ConditionSceneSlide extends BaseSceneSlide {
  plant!: PlantDetailDTO;
  sceneId!: string;
  conditions: ConditionDTO[] = [];
  slideType = SceneSlideType.CONDITION;

  mounted() {
    this.items = this.conditions;
    this.$nextTick(() => super.inferSlideType());
  }

  unmounted() {
    super.unmounted();
  }
}
